"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteXyZdyDragging = deleteXyZdyDragging;
exports.getXyZdyDragging = getXyZdyDragging;
exports.getXyZdyDraggingPage = getXyZdyDraggingPage;
exports.updateStatus = updateStatus;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
var BASE = '/xyZdyDragging';

/**
 * 分页查询自定义页面
 * @param {Object} params { page, limit, name }
 */
function getXyZdyDraggingPage(params) {
  return (0, _requestAuth.default)({
    url: BASE + '/page',
    method: 'get',
    params: params
  });
}

/**
 * 单条详情（列表页编辑用）
 * @param {String|Number} id
 */
function getXyZdyDragging(id) {
  return (0, _requestAuth.default)({
    url: BASE + '/' + id,
    method: 'get'
  });
}

/**
 * 删除
 * @param {String|Number} id
 */
function deleteXyZdyDragging(id) {
  return (0, _requestAuth.default)({
    url: BASE + '/' + id,
    method: 'delete'
  });
}
/**
 * 切换启用/发布状态
 * @param {Object} params { id, enable }
 */
function updateStatus(params) {
  return (0, _requestAuth.default)({
    url: BASE + '/updateStatus?id=' + params.id + '&enable=' + params.enable,
    method: 'post'
  });
}